import { FeatureCardRequest } from '@in-life-and-loyalty/vaps-feature-cinchcharge-request'
import type { GetStaticProps } from 'next'

function CardRequestPage() {
  return <FeatureCardRequest />
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  try {
    return {
      props: {
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          showBorderRadius: true,
          showFooterBorderRadius: false,
        },
      },
      revalidate: 60, // In seconds
    }
  } catch {
    return { notFound: true } as const
  }
}

export default CardRequestPage
